import { DataStringComponent } from "./data-string-component.js";
import { isNumber } from "@bonusmap/shared_ui/library";

export class DataDateComponent extends DataStringComponent {
    static webComponentName: string = "data-date";
    protected _templateId: string = "data-date-template";
    protected inputType: string = "date"; 
    constructor() {
        super();
    }
    
    addDataForTemplate(): Record<string, any> {
        const baseData = super.addDataForTemplate();
        
        // Convert ISO string to YYYY-MM-DD format for date input
        let editValue = this.value;
        if (this.value && typeof this.value === 'string') {
            const date = new Date(this.value);
            if (isNumber(date.getTime())) {
                editValue = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            }
        }
        
        // Format for display in Italian
        let displayValue = this.value;
        if (this.value && typeof this.value === 'string') {
            const date = new Date(this.value);
            if (isNumber(date.getTime())) {
                displayValue = date.toLocaleDateString('it-IT', {
                    day: '2-digit',
                    month: '2-digit', 
                    year: 'numeric'
                });
            }
        }
        
        return {
            ...baseData,
            editValue,
            displayValue
        };
    }

}
